import { ArrowDownUp, Settings, Lock, Unlock, Sun, Moon, LogOut } from 'lucide-react';
import { useTheme } from 'next-themes';

/**
 * Sidebar footer: import/export, settings, user info, theme toggle, logout.
 */
export default function SidebarFooter({
  user, logout, isEncryptionEnabled, isVaultLocked,
  onOpenImportExport, onOpenSettings,
}) {
  const { theme, setTheme } = useTheme();

  return (
    <div className="p-3 border-t border-border/50 space-y-0.5">
      <button
        onClick={onOpenImportExport}
        className="flex items-center gap-3 w-full min-h-[40px] py-2 px-2 text-sm text-muted-foreground hover:text-foreground active:text-foreground transition-colors rounded-sm"
        data-testid="sidebar-import-export"
      >
        <ArrowDownUp className="w-4 h-4" />
        Import / Export
      </button>
      <button
        onClick={onOpenSettings}
        className="flex items-center gap-3 w-full min-h-[40px] py-2 px-2 text-sm text-muted-foreground hover:text-foreground active:text-foreground transition-colors rounded-sm"
        data-testid="sidebar-settings-btn"
      >
        <Settings className="w-4 h-4" />
        Settings
      </button>

      <div className="flex items-center justify-between pt-2 border-t border-border/30 mt-2">
        <span className="text-xs text-muted-foreground truncate max-w-[150px]" title={user?.email}>
          {user?.email}
        </span>
        <div className="flex items-center gap-0.5">
          {isEncryptionEnabled && (
            <button
              onClick={onOpenSettings}
              className={`p-2 rounded-sm transition-colors ${isVaultLocked ? 'text-accent-amber' : 'text-green-400 hover:text-green-300'}`}
              title={isVaultLocked ? 'Vault locked — open security settings' : 'Vault unlocked — open security settings'}
              data-testid="sidebar-encryption-status"
            >
              {isVaultLocked ? <Lock className="w-4 h-4" /> : <Unlock className="w-4 h-4" />}
            </button>
          )}
          <button
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            className="p-2 rounded-sm text-muted-foreground hover:text-foreground active:text-foreground transition-colors"
            data-testid="sidebar-theme-toggle"
          >
            {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
          <button
            onClick={logout}
            className="p-2 rounded-sm text-muted-foreground hover:text-red-400 active:text-red-400 transition-colors"
            data-testid="sidebar-logout-btn"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
